import type { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";

// NOTE: No wildcard "*" route.
// This is a single-page app with one valid route.
// Removing the catch-all means React Router will NOT re-render
// when the GHL chat widget calls pushState with an unknown path —
// it simply ignores paths it doesn't recognise, keeping Home rendered.
const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
];

export default routes;
